import React from "react";
import {  MDBContainer } from "mdbreact";


const Development = () => {
    return (
        <MDBContainer id="development" className="text-center my-5">
            <h2 className="h1-responsive font-weight-bold my-5">
                Development
            </h2>
            <p className="lead black-text w-responsive mx-auto mb-5">
                Our team can work with you to build simple and effective websites 
                to promote your Brand, Product or Business, Or highly interactive 
                Web applications to enhance your customers experience or take 
                their experience mobile with a responsive website or native mobile app.
            </p>
        </MDBContainer>
    );
}

export default Development;